import {
  BoxStyleProps,
  TransactionDropdown as TransactionDropdownBase,
} from '@frontend/ui-library';
import { notEmpty, roundCrypto } from '@frontend/utils';
import getTxHashById from '../../utils/gettxHashByUrl';

import { TransactionListingFieldsFragment } from '../../graphql/generated';
import { ApiChainSymbols, binancePayAsBlockchain } from '../../utils';

type TransactionStatus = 'detected' | 'confirmed';

export type TransactionWithStatus = TransactionListingFieldsFragment & {
  status: TransactionStatus;
};

type Transactions = Array<TransactionWithStatus | null>;

export interface TransactionDropdownProps extends BoxStyleProps {
  transactions: Transactions;
}

const TransactionDropdown = ({
  transactions,
  ...otherProps
}: TransactionDropdownProps) => {
  const sortedTransactions = transactions.sort(
    (a, b) => Date.parse(b?.createdAt || '') - Date.parse(a?.createdAt || '')
  );

  const isLightningNetwork = transactions.some(
    (transaction) => transaction?.blockchain === 'LN-BTC'
  );

  const isBinancePay = transactions.some(
    (transaction) => transaction?.blockchain === binancePayAsBlockchain
  );

  if (!transactions?.length || isLightningNetwork || isBinancePay) {
    return null;
  }

  return (
    <TransactionDropdownBase
      data-test-id="transaction-dropdown"
      transactions={sortedTransactions.map((t) => ({
        hash: getTxHashById(
          t?.txId || '',
          (t?.blockchain as ApiChainSymbols) || ''
        ),
        value: `${roundCrypto(Number(t?.cryptoAmount)) || ''} ${
          t?.cryptoCurrency.toUpperCase() || ''
        }`,
        status: t?.status === 'confirmed' ? 'confirmed' : 'confirming',
        link: t?.txUrl || '',
        date: t?.createdAt || '',
      }))}
      {...otherProps}
    />
  );
};

export function addStatusToTransactions(
  transactions: Array<TransactionListingFieldsFragment | null>,
  status: TransactionStatus
) {
  return transactions.filter(notEmpty).map((t) => ({
    ...t,
    status,
  }));
}

export default TransactionDropdown;
